import { render, staticRenderFns } from "./EcommerceMember.vue?vue&type=template&id=87acd7f8&"
import script from "./EcommerceMember.vue?vue&type=script&lang=js&"
export * from "./EcommerceMember.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceMember.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports